var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "add-on-container"
  }, [_c('div', {
    staticClass: "add-on-list"
  }, [_vm._m(0), _c('div', {
    staticClass: "checkboxes-container"
  }, [_c('h4', {
    staticClass: "section-title"
  }, [_vm._v("請確認加值項目")]), _c('Checkboxes', {
    attrs: {
      "options": _vm.options,
      "value-key": 'value',
      "label-key": 'label',
      "right-display-key": 'right_display_info',
      "detailed-info-key": 'detailed_info',
      "expandable-key": 'expandable'
    },
    scopedSlots: _vm._u([{
      key: "details",
      fn: function fn(_ref) {
        var details = _ref.details;
        return [_c('div', {
          staticClass: "info-title"
        }, [_vm._v("詳細資訊")]), Array.isArray(details) ? _c('ul', {
          staticClass: "info-list"
        }, _vm._l(details, function (t, i) {
          return _c('li', {
            key: i
          }, [_vm._v(_vm._s(t))]);
        }), 0) : _c('div', [_vm._v(_vm._s(details))])];
      }
    }]),
    model: {
      value: _vm.proxy,
      callback: function callback($$v) {
        _vm.proxy = $$v;
      },
      expression: "proxy"
    }
  })], 1)]), _c('div', {
    staticClass: "cost-summary"
  }, [_c('h4', [_vm._v("費用摘要")]), _c('div', {
    staticClass: "summary-item"
  }, [_c('span', [_vm._v("基本費用")]), _c('span', [_vm._v(_vm._s(_vm.baseFee) + " 元")])]), _c('div', {
    staticClass: "summary-item"
  }, [_c('span', [_vm._v("加值費用")]), _c('span', [_vm._v(_vm._s(_vm.addOnTotal) + " 元")])]), _c('hr'), _c('div', {
    staticClass: "summary-total"
  }, [_c('span', [_vm._v("總金額")]), _c('span', [_vm._v(_vm._s(_vm.totalCost) + " 元")])]), _vm.selectedAddOns.length ? _c('div', {
    staticClass: "selected-addons"
  }, [_c('div', {
    staticClass: "selected-title"
  }, [_vm._v("已選擇加價項目")]), _c('ul', {
    staticClass: "selected-list"
  }, _vm._l(_vm.selectedAddOns, function (item) {
    return _c('li', {
      key: item.value
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.label))]), _c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.right_display_info))])]);
  }), 0)]) : _vm._e()])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "page-kicker"
  }, [_vm._v("健康加值｜自費健檢")]), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("加值健檢")]), _c('div', {
    staticClass: "page-subtitle"
  }, [_vm._v("選擇適合您的額外檢查項目")])]);
}]

export { render, staticRenderFns }